import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type BookingSlot, bookingSlots } from "../schemas/bookingSlots";

export const getBookingSlotsProps = z
  .object({
    bookingMarket: z.string(),
  })
  .extend(requestConfig.shape);

export type GetBookingSlotsProps = z.infer<typeof getBookingSlotsProps>;

export const getBookingSlots = async (
  args: GetBookingSlotsProps,
): Promise<BookingSlot[]> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    proxyAuthSecret,
    bookingMarket,
  } = parseServiceInput(getBookingSlotsProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    // no token necessary for Booking endpoints
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const params = new URLSearchParams({
    bookingMarket,
  });

  const response = await fetch(
    `${endpoint}/v1/bookings/slots?${params.toString()}`,
    {
      method: "GET",
      headers,
    },
  );

  const data = await parseServiceOutput(response, bookingSlots, {
    code: "MALFORMED_SLOTS",
    message: "Issue getting slots",
  });
  return data.meetingTypes;
};
